@if (initialized$ | async) {
  <router-outlet></router-outlet>
}


